import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { toast } from 'react-toastify';
import '../css/Dashboard.css';
import '../css/bootstrap-grid.min.css';

import { APIURI, APIKEY } from '../config';

export default function Rewards() {

    const [cookies, setCookie] = useCookies(['cookies']);

    const [rewards, setRewards] = useState(0);
    const [hasClaimedDailyReward, setHasClaimedDailyReward] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const userStats = {
        balance: '0 RAND',
        tasksCompleted: 0,
        totalRewards: '22.670 RAND',
        dailyReward: '1.000 RAND',
    };

    const tasks = [
        { id: 1, name: 'Complete daily login', reward: '0.5 RAND', description: 'Log in daily to claim your reward.' },
        { id: 2, name: 'Refer a friend', reward: '1 RAND', description: 'Refer a friend and earn rewards once they sign up.' },
        { id: 3, name: 'Participate in survey', reward: '0.75 RAND', description: 'Complete our survey and help us improve.' },
    ];

    async function fetchRewards() {

        let data = {
            sessionId: cookies.phenixSession,
            APIKey: APIKEY
        }
        let params = new URLSearchParams(data).toString();
        let url = APIURI + '/user/rewards?' + params;

        try {

            const response = await fetch(url, {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (!response.ok) {
                return;
            } else {
                const result = await response.json();
                console.log(result);
                if (result.data.rewards !== undefined && result.data.rewards !== null) {
                    setRewards(result.data.rewards);
                    return;
                }
            }
        } catch (e) {
            toast.error(e);
        }
    }

    useEffect(() => {
        if (cookies?.phenixSession?.length > 0 && cookies?.phenixSignature?.length > 0) {
            console.log("valid cookie");

            fetchRewards();

        } else {
            console.error("invalid cookie");
            return;
        }
    }, [cookies])



    const claimDailyReward = () => {
        console.log("Daily reward claimed!");
        setHasClaimedDailyReward(true);
    };

    const openModal = (task) => {
        setSelectedTask(task);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="dashboard">
            <header className="dashboard-header">
                <h1 className="title">Bitmobile Phēnix X</h1>
                <div>Welcome, <b>Eric </b></div>
            </header>

            <div className="dashboard-content">
                <div className="row" style={{ width: "80%", maxWidth: "600px" }}>
                    <section className="section col-12 col-md-4">
                        <div className="section-title">Your Balance</div>
                        <div className="stat-box glass">
                            <div className="stat-value">{rewards}</div>
                        </div>
                    </section>

                    <section className="section col-12 col-md-4">
                        <div className="section-title">Tasks Completed</div>
                        <div className="stat-box glass">
                            <div className="stat-value">{userStats.tasksCompleted}</div>
                        </div>
                    </section>

                    <section className="section col-12 col-md-4">
                        <div className="section-title">Total Rewards</div>
                        <div className="stat-box glass">
                            <div className="stat-value">{userStats.totalRewards}</div>
                        </div>
                    </section>
                </div>

                <div className="daily-reward-section glass">
                    <div className="section-title" style={{ width: "100%" }}>Daily Reward</div>
                    <p>Claim your daily reward for being a valued device owner.</p>
                    <button className="btn-claim" onClick={claimDailyReward} disabled={hasClaimedDailyReward}>
                        {hasClaimedDailyReward ? 'Reward Claimed' : 'Claim Reward'}
                    </button>
                </div>

                <div className="tasks-section row">
                    <div className="section-title" style={{ margin: "auto" }}>Earn Rewards</div>
                    <div className="tasks-list glass row" style={{ margin: "auto" }}>
                        {tasks.map(task => (
                            <div key={task.id} className="task-item col-12">
                                <div className="task-name">{task.name}</div>
                                <div className="task-reward">{task.reward}</div>
                                <button onClick={() => openModal(task)} className="btn-claim">View Task</button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {isModalOpen && selectedTask && (
                <div className="modal">
                    <div className="modal-content glass">
                        <span className="close" onClick={closeModal}>&times;</span>
                        <h3>{selectedTask.name}</h3>
                        <p>{selectedTask.description}</p>
                        <button className="btn-claim" onClick={() => { /* Implement task navigation logic here */ }}>Go to Task</button>
                    </div>
                </div>
            )}

            <footer className="dashboard-footer">
                &copy; Copyright 2024 Finnovant
            </footer>
        </div>
    );
}
